import { createAsyncThunk } from '@reduxjs/toolkit';
import { getUnsubscribedUsers } from '../../firebase/api/unsubscribed_users';

export const fetchUnsubscribedUsers = createAsyncThunk(
    'fetchUnsubscribedUsers',
    async (email, { rejectWithValue }) => {
        try {
            let res = [];
            let isAlreadyUnsub = false;
            await getUnsubscribedUsers().then(items => {
                res = [...items];
                isAlreadyUnsub = !!res.filter(item => item.email === email).length;
            });

            return {
                data: res,
                isAlreadyUnsub: isAlreadyUnsub,
            };
        } catch (e) {
            return rejectWithValue(e.message);
        }
    }
);
